import { AnalyticsTransformer, TrackingData } from '@panamax/app-state';

export const paymentDashboardPageLoad: AnalyticsTransformer = (
  tracking: TrackingData,
) => ({
  capability: tracking.data.capability,
  event: tracking.data.event,
  page: {
    pageName: tracking.data.pageName,
  },
});

export const paymentTileClick: AnalyticsTransformer = (
  tracking: TrackingData,
) => ({
  capability: tracking.data.capability,
  event: tracking.data.event,
  page: {
    pageName: tracking.data.pageName,
  },
  button: {
    buttonName: tracking.data.buttonName,
  },
});

export const paymentOutboundLink: AnalyticsTransformer = (
  tracking: TrackingData,
) => ({
  capability: tracking.data.capability,
  event: tracking.data.event,
  page: {
    pageName: tracking.data.pageName,
  },
  link: {
    url: tracking.data.linkURL,
  },
});

export const paymentDashboardSearch: AnalyticsTransformer = (
  tracking: TrackingData,
) => ({
  capability: tracking.data.capability,
  event: tracking.data.event,
  page: {
    pageName: tracking.data.pageName,
  },
  search: {
    term: tracking.data.searchTerm,
  },
});

export const paymentDashboardModalOpen: AnalyticsTransformer = (
  tracking: TrackingData,
) => ({
  capability: tracking.data.capability,
  event: tracking.data.event,
  page: {
    pageName: tracking.data.pageName,
  },
  modal: {
    name: tracking.data.modalName,
  },
});
